import template from './alert-container.html';

export default function AlertContainer(ktAlert) {
    'ngInject';

    return {
        restrict: 'E',
        template,
        scope: true,
        bindToController: true,
        controller: ktAlertContainer,
        controllerAs: 'ktAlertContainer',
    };

    function ktAlertContainer() {
        const vm = this;
        activate();

        function activate() {
            vm.alerts = ktAlert.getAlerts();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/message-alert/alert-container-directive.js